'use client'

import { ArrowUpIcon } from 'lucide-react'
import { Button } from '../ui/button'

export function BackToTopButton() {
  return (
    <Button
      variant='outline'
      size='md'
      className='w-max'
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <span>Back to top</span>
      <ArrowUpIcon className='w-6 h-6' />
    </Button>
  )
}
